import { css } from '@lastbrand/web-ui-styled-system/css'

import { isModifiedClickEvent } from '@src/utils/click-event.utils'

interface MobileSubCollectionChipProps {
  label: string
  selected?: boolean
  onClick?: () => void
  /** Subcollection URL. When set the chip renders as a crawlable anchor (SEO); plain clicks still filter in place. */
  href?: string
}

export default function MobileSubCollectionChip({
  label,
  onClick,
  selected = false,
  href,
}: MobileSubCollectionChipProps) {
  const rootClassName = css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '32px',
    paddingX: 'space-10',
    paddingY: 'space-8',
    borderRadius: 'radius-round',
    border: selected ? 'none' : '1px solid',
    borderColor: selected ? 'transparent' : 'lightgray',
    bg: selected ? 'black' : 'white',
    color: selected ? 'white' : 'black',
    textStyle: selected ? 'body-12-strong' : 'body-12',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'background-color 150ms ease-out, border-color 150ms ease-out, color 150ms ease-out',
    _hover: {
      bg: selected ? 'black' : 'paperwhite',
    },
    _active: {
      bg: selected ? 'black' : 'offwhite',
    },
    _focusVisible: {
      outlineWidth: '2px',
      outlineOffset: '0.25rem',
      outlineColor: 'black',
      outlineStyle: 'solid',
    },
  })

  if (href) {
    return (
      <a
        href={href}
        aria-current={selected ? 'true' : undefined}
        onClick={event => {
          // Modified clicks (new tab/window, middle-click) follow the crawlable href;
          // plain clicks keep the in-app filter/toggle navigation.
          if (isModifiedClickEvent(event)) return
          event.preventDefault()
          onClick?.()
        }}
        className={rootClassName}
      >
        {label}
      </a>
    )
  }

  return (
    <button type="button" aria-pressed={selected} onClick={onClick} className={rootClassName}>
      {label}
    </button>
  )
}
